import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "container animated fadeIn" }
const _hoisted_2 = {
  key: 0,
  class: "rounded shadow p-5 mx-0"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "font-weight-bold h4 mb-3 text-left"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "font-weight-bold h4 mb-3 text-left"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString('Create New Authorized Signer'))
const _hoisted_10 = { class: "row text-left" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "Full Legal Name*", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", null, "Email*", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "ID*", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("small", { style: {"font-size":"10px"} }, " Please upload in colour, and the front and back if using license(s). ", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Current file ")
const _hoisted_23 = { class: "col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "ID (Back)", -1)
const _hoisted_25 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Current file ")
const _hoisted_27 = { class: "col-sm-12 col-md-6 col-lg-6 col-xl-6" }
const _hoisted_28 = /*#__PURE__*/_createVNode("small", null, " The beneficial owner involved with, related, or closely associated with members of government?* ", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "form-check form-check-inline" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialGovernmentYes"
}, " Yes ", -1)
const _hoisted_32 = { class: "form-check form-check-inline" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "beneficialGovernmentNo"
}, " No ", -1)
const _hoisted_34 = { class: "row text-left" }
const _hoisted_35 = { class: "col-12 mt-3 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.userProfile)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock("p", _hoisted_5, [
                    _createVNode("a", {
                      href: "#",
                      class: "text-dark mr-2",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
                    }, [
                      _hoisted_6
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.currentSigner.name), 1)
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_7, [
                    _createVNode("a", {
                      href: "#",
                      class: "text-dark mr-2",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
                    }, [
                      _hoisted_8
                    ]),
                    _hoisted_9
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.signerForm.props.name = $event)),
                class: "form-control form-control-sm",
                type: "text"
              }, null, 512), [
                [_vModelText, _ctx.signerForm.props.name]
              ]),
              (_ctx.signerForm.controls.name.dirty)
                ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.signerForm.controls.name.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.signerForm.props.email = $event)),
                class: "form-control form-control-sm",
                type: "email"
              }, null, 512), [
                [_vModelText, _ctx.signerForm.props.email]
              ]),
              (_ctx.signerForm.controls.email.dirty)
                ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.signerForm.controls.email.errorMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("input", {
                onInput: _cache[5] || (_cache[5] = e => _ctx.onEntryFile(e, 'idSigner')),
                id: "idSigner",
                type: "file",
                class: "form-control form-control-sm",
                accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
              }, null, 32),
              _hoisted_19,
              (_ctx.signerForm.controls.identification.dirty)
                ? (_openBlock(), _createBlock("small", _hoisted_20, _toDisplayString(_ctx.signerForm.controls.identification.errorMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.isEditing && _ctx.signerForm.props.identification)
                ? (_openBlock(), _createBlock("small", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("a", {
                      class: "link pointer",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadDocument(_ctx.signerForm.props.identification)))
                    }, _toDisplayString(_ctx.signerForm.props.identification.key), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _createVNode("input", {
                onInput: _cache[7] || (_cache[7] = e => _ctx.onEntryFile(e, 'idSignerBack')),
                id: "idSigner",
                type: "file",
                class: "form-control form-control-sm",
                accept: "application/pdf,image/png,image/jpeg,image/jpg,.doc,.docx,"
              }, null, 32),
              (_ctx.isEditing && _ctx.signerForm.props.identificationBack)
                ? (_openBlock(), _createBlock("small", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("a", {
                      class: "link pointer",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (
                _ctx.downloadDocument(_ctx.signerForm.props.identificationBack)
              ), ["prevent"]))
                    }, _toDisplayString(_ctx.signerForm.props.identificationBack.key), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_27, [
              _hoisted_28,
              _hoisted_29,
              _createVNode("div", _hoisted_30, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  id: "beneficialGovernmentYes",
                  value: true,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.signerForm.props.withGovernment = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.signerForm.props.withGovernment]
                ]),
                _hoisted_31
              ]),
              _createVNode("div", _hoisted_32, [
                _withDirectives(_createVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  id: "beneficialGovernmentNo",
                  value: false,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.signerForm.props.withGovernment = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.signerForm.props.withGovernment]
                ]),
                _hoisted_33
              ])
            ])
          ]),
          _createVNode("div", _hoisted_34, [
            _createVNode(_component_ConfirmDialog, {
              breakpoints: { '960px': '75vw', '640px': '100vw' },
              style: { width: '50vw' }
            }),
            _createVNode("div", _hoisted_35, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                class: "btn btn-sm btn-primary"
              }, " Save ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}